export default __webpack_public_path__ + "static/media/meetings_n.a6bdaeb3.svg";